(function () {
  'use strict';
  if (window.EliteProductWallets) return;
  window.EliteProductWallets = true;
  var root = window.Shopify && window.Shopify.routes.root || '/';
  document.querySelectorAll('[data-elite-pack-wallets]').forEach(function (host) {
    var form = document.getElementById(host.dataset.form), prepare = host.querySelector('[data-wallet-prepare]');
    var output = host.querySelector('[data-wallet-output]'), status = host.querySelector('[data-wallet-status]');
    var pending = false, ready = false, timer, deadline = 0, before = '', loading = false, baseline, expected;
    if (!form || !prepare) return;
    function pairSelected() {
      var pack = form.querySelector('input[name="phantom_pack"]:checked,input[name="gear_pack"]:checked,#elite-page-bundle input:checked');
      return pack && pack.value === '2';
    }
    function sync() {
      var pair = pairSelected();
      host.hidden = !pair;
      form.classList.toggle('elite-pair-wallet-mode', !!pair);
      if (!pair) { pending = false; clearTimeout(timer); }
    }
    function fingerprint(cart) {
      return JSON.stringify((cart.items || []).map(function (item) { return [item.key,item.quantity,item.final_line_price]; }));
    }
    async function readCart() {
      var response = await fetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    }
    function mainButton() { return form.querySelector('[data-buy],[data-gear-buy],.product-form__add-button'); }
    function selection() {
      if (form.dataset.elitePairVariantId) return {items:[{id:Number(form.dataset.elitePairVariantId),quantity:1}],total:Number(form.dataset.elitePairPrice)};
      var product = form.closest('[data-phantom-product],[data-phantom-gear-product]');
      if (!product) return null;
      var variants = JSON.parse(product.dataset.variants), items = [], total = 0;
      if (product.hasAttribute('data-phantom-product')) {
        Array.from(form.querySelectorAll('[data-piece]')).forEach(function (piece,index) {
          var options=Array.from(piece.querySelectorAll('[data-option-index]')).map(function(select){return select.value;});
          var variant=variants.find(function(entry){return entry.options.every(function(value,i){return String(value)===String(options[i]);});});
          if (!variant || !variant.available) throw new Error('Unavailable selection');
          items.push({id:Number(variant.id),quantity:1}); total+=index ? Math.round(variant.price*0.6) : variant.price;
        });
        product.querySelectorAll('[data-extra-choice]').forEach(function(extra){
          var check=extra.querySelector('[data-choice-check]'), select=extra.querySelector('[data-choice-select]');
          if (!check || !check.checked || !select) return;
          var variant=JSON.parse(extra.dataset.choiceVariants).find(function(entry){return String(entry.id)===select.value;});
          if (!variant || !variant.available) throw new Error('Unavailable extra');
          items.push({id:Number(variant.id),quantity:1});
          if(extra.dataset.choiceKind!=='gift') total+=variant.price;
        });
      } else {
        var id=Number(form.querySelector('[data-gear-variant]').value), variant=variants.find(function(entry){return Number(entry.id)===id;});
        if(!variant || !variant.available) return null;
        items=[{id:id,quantity:2}]; total=variant.price+Math.ceil(variant.price*0.6);
      }
      return {items:items,total:total};
    }
    function quantity(cart,id){return (cart.items||[]).filter(function(item){return Number(item.variant_id||item.id)===id;}).reduce(function(sum,item){return sum+item.quantity;},0);}
    function selectionConfirmed(cart,alreadyAdded){
      if (!expected || !Number.isSafeInteger(expected.total)) return false;
      var totals=new Map();expected.items.forEach(function(item){totals.set(item.id,(totals.get(item.id)||0)+item.quantity);});
      return Array.from(totals).every(function(entry){return quantity(cart,entry[0])>=(alreadyAdded?0:quantity(baseline,entry[0]))+entry[1];}) && (alreadyAdded || cart.total_price-baseline.total_price===expected.total);
    }
    async function renderWallets() {
      var response = await fetch(root + '?section_id=elite-product-wallets', {credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('Wallets unavailable');
      var page = new DOMParser().parseFromString(await response.text(),'text/html');
      var panel = page.querySelector('[data-native-cart-wallets]');
      if (!panel || !panel.querySelector('shopify-accelerated-checkout-cart,.additional-checkout-buttons')) throw new Error('Wallets unavailable');
      output.replaceChildren(document.importNode(panel,true));
      ready = true; pending = false; prepare.disabled = false;
      status.textContent = host.dataset.readyCopy;
      var drawer = document.getElementById('mini-cart');
      var toggle = document.querySelector('.header__cart-toggle');
      if (drawer && drawer.getAttribute('aria-hidden') === 'false' && toggle) toggle.click();
      host.scrollIntoView({behavior:'smooth',block:'center'});
    }
    async function check() {
      if (!pending || loading) return;
      if (Date.now() > deadline) {
        pending = false; prepare.disabled = false; status.textContent = host.dataset.errorCopy; return;
      }
      loading = true;
      try {
        var cart = await readCart(), button = mainButton();
        if (cart.item_count > 0 && (!button || !button.disabled) && fingerprint(cart) !== before && selectionConfirmed(cart,false)) await renderWallets();
      } catch (error) {
        pending = false; prepare.disabled = false; status.textContent = host.dataset.errorCopy;
      } finally {
        loading = false;
        if (pending) timer = setTimeout(check,350);
      }
    }
    prepare.addEventListener('click', async function () {
      if (pending) return;
      var button = mainButton();
      if (!button || button.disabled) return;
      prepare.disabled = true; status.textContent = host.dataset.loadingCopy;
      try {
        var cart = await readCart(); before = fingerprint(cart); baseline=cart; expected=selection();
        if (!expected) throw new Error('Selection cannot be confirmed');
        if (/^(?:REVIEW|REVISAR|VER CARRINHO)/i.test(button.textContent.trim()) && cart.item_count > 0) { if(!selectionConfirmed(cart,true)) throw new Error('Selection changed'); await renderWallets(); return; }
        pending = true; deadline = Date.now() + 20000;
        button.click();
        timer = setTimeout(check,350);
      } catch (error) {
        pending = false; prepare.disabled = false; status.textContent = host.dataset.errorCopy;
      }
    });
    form.addEventListener('change',function () {
      ready = false; output.replaceChildren(); status.textContent = ''; sync();
    });
    new MutationObserver(sync).observe(form,{childList:true,subtree:true,attributes:true,attributeFilter:['checked','data-elite-pair-variant-id']});
    ['cart:updated','cart:refresh','product:added'].forEach(function (event) {
      document.addEventListener(event,function () {
        if (pending) { clearTimeout(timer); timer=setTimeout(check,150); }
        else if (ready) { ready=false; output.replaceChildren(); status.textContent=''; }
      });
    });
    sync();
  });
}());
